import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet'
import Layout from '../components/Layout'
import Background from '../components/Background'
import PrismicDOM from 'prismic-dom'
import {RichText} from 'prismic-reactjs';
import Link from 'gatsby-link'
import styled from 'styled-components'
import Grid from 'styled-components-grid';
import {Margin, Padding, py} from 'styled-components-spacing'
import {GridContainer, FullImage, IntroGridUnit, SpacedGridUnit} from '../components/Styles'
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import { isEmail, isEmpty, isLength } from 'validator';
import Modal from '@material-ui/core/Modal';
import Section from '../components/Section';
import Recaptcha from "react-google-recaptcha";

const RECAPTCHA_KEY = process.env.SITE_RECAPTCHA_KEY;

const RelativeLink = styled(Link)`
  position: relative;
  display: block;
`;
const Name = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  background: linear-gradient(to left, rgba(255,255,255,.1), rgba(255,255,255,.8), rgba(255,255,255,.1));
  left: 0;
  text-align: center;
  ${py(2)};
  color: black;
`;
const styles = theme => ({
  paper: {
    top: '50%',
    left: '50%',
    transform: `translate(-50%, -50%)`,
    position: 'absolute',
    width: theme.spacing.unit * 50,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
  },
});

const ImageLink = (props) => (
  <Grid.Unit size={1/3}>
    <Margin horizontal={2}>
      <RelativeLink to={props.to}>
        <FullImage src={props.image} />
        <Name>{props.name}</Name>
      </RelativeLink>
    </Margin>
  </Grid.Unit>
);

const BotTrap = styled.p`
  display: none;
`;

const encode = (data) => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
}

class IndexPage extends React.Component {
  constructor(props){
    super(props);
    this.state = { 
      nom: "", 
      prenom: "", 
      email: "",
      tel: '',
      sujet: '',
      contenu: '',
      "g-recaptcha-response": null,
      error: false,
      alert: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleRecaptcha = this.handleRecaptcha.bind(this);
  }
  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }
  handleRecaptcha(value) {
    this.setState({ "g-recaptcha-response": value });
  }

  handleSubmit(e) {
    e.preventDefault();
    if (!isEmpty(this.state.prenom, {ignore_whitespace:true}) &&
        !isEmpty(this.state.nom, {ignore_whitespace:true}) &&
        !isEmpty(this.state.sujet, {ignore_whitespace:true}) &&
        isEmail(this.state.email) && 
        isLength(this.state.contenu, {min:10, max: undefined})
     ) {
      fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encode({ "form-name": "contact-airfly", ...this.state })
      })
        .then(() => this.setState({error:false, alert:true}))
        .catch(error => this.setState({error:true, alert:false}));   
    }
  }
  render() {
    const { data, classes } = this.props;
    const { nom, prenom, tel, email, sujet, contenu } = this.state;
    const content = data.content.data;  
    return (
      <Layout 
        navigationLinks={data.menu.data.body}
        meteoLinks={data.meteo.data}
        pagesUrl={data.allPagesUrl}
        bannerImages={content.header_images}
      >
       <Helmet
        title={content.meta_title}
        meta={[
          { name: 'description', content: content.meta_description }
        ]}
        />
        <Background backgroundImage={content.background}>
          <Padding bottom={4}>
            <GridContainer>
              <Grid horizontalAlign="center">
                <IntroGridUnit>
                  {RichText.render(content.introduction)}
                </IntroGridUnit>
              </Grid>
              { content.body &&
                <div>
                  {content.body.map(({primary}, index) => (
                    <Section primary={primary} index={index} pagesUrl={data.allPagesUrl} />
                  ))}
                </div>
              }
              <Grid horizontalAlign="center">
                <Margin horizontal={2}>
                  <Grid valign='center'>
                    <Grid.Unit size={{mobile:1,tablet:1/3}}>
                      { content.image.url &&
                        <FullImage src={content.image.url} alt="Contacter AirFly pour apprendre le parapenthe" /> 
                      }
                    </Grid.Unit>
                    <Grid.Unit size={{mobile:1,tablet:2/3}}>
                      <Margin all={2}>
                        <SpacedGridUnit>
                          <form 
                            name="contact-airfly" 
                            method="POST" 
                            data-netlify="true" 
                            data-netlify-recaptcha="true"
                            action="/" 
                            onSubmit={this.handleSubmit}>
                            <FormControl fullWidth>
                              <input type="hidden" name="form-name" value="contact-airfly" />
                              <Grid horizontalAlign="right">
                                <Grid.Unit size={1/2}>
                                  <Margin vertical={2}>
                                    <TextField required value={nom} fullWidth name="nom" id="nom" label="Nom" onChange={this.handleChange} />
                                  </Margin>
                                </Grid.Unit>
                                <Grid.Unit size={1/2}>
                                  <Margin vertical={2}>
                                    <TextField required value={prenom} fullWidth name="prenom" id="prenom" label="Prénom" onChange={this.handleChange} />
                                  </Margin>
                                </Grid.Unit>
                                <Grid.Unit size={1}>
                                  <Margin vertical={2}>
                                    <TextField value={tel} fullWidth name="tel" id="tel" label="Téléphone" type="tel" onChange={this.handleChange} />
                                  </Margin>
                                </Grid.Unit>
                                <Grid.Unit size={1}>
                                  <Margin vertical={2}>
                                    <TextField required value={email} fullWidth name="email" id="email" label="e-mail" type="email" onChange={this.handleChange} />
                                  </Margin>
                                </Grid.Unit>
                                <Grid.Unit size={1}>
                                  <Margin vertical={2}>
                                    <TextField required value={sujet} fullWidth name="sujet" id="sujet" label="Sujet" onChange={this.handleChange} />
                                  </Margin>
                                </Grid.Unit>
                                <Grid.Unit size={1}>
                                  <Margin vertical={2}>
                                    <TextField required value={contenu} multiline fullWidth name="contenu" id="contenu" label="Préciser votre demande en quelques lignes" onChange={this.handleChange} />
                                  </Margin>
                                </Grid.Unit>
                                <Grid.Unit size={1}>
                                  <Margin vertical={2}>
                                    <Recaptcha
                                      ref="recaptcha"
                                      sitekey={RECAPTCHA_KEY}
                                      onChange={this.handleRecaptcha}
                                    />
                                  </Margin>
                                </Grid.Unit>
                                <Grid.Unit size={1/5}>
                                  <Margin top={2}>
                                    <Button variant="contained" fullWidth color="primary" type="submit">
                                      Envoyer
                                    </Button>
                                    <Modal
                                      aria-labelledby="simple-modal-title"
                                      aria-describedby="simple-modal-description"
                                      open={this.state.alert}
                                      onClose={() => this.setState({
                                        alert:false,
                                        tel: '',
                                        nom: '',
                                        prenom:'',
                                        email:'',
                                        sujet:'',
                                        contenu:''
                                      })}
                                    >
                                      <div className={classes.paper}>
                                        {this.state.error ? (
                                          <p>Une erreur s'est produite</p>
                                          ) : (
                                          <p>Merci pour votre message!</p>
                                          )
                                        }
                                      </div>
                                    </Modal>
                                  </Margin>
                                </Grid.Unit>
                              </Grid>
                            </FormControl>
                          </form>
                        </SpacedGridUnit>
                      </Margin>
                    </Grid.Unit>
                  </Grid>
                </Margin>
              </Grid>
            </GridContainer>
          </Padding>
        </Background>
      </Layout>
    )
  }
}

IndexPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

const IndexPageWrapped = withStyles(styles)(IndexPage);


export default IndexPageWrapped

export const query = graphql`
  query PageContactContent {
    menu: prismicDocument(type: {eq: "navigation"}) {
      ...NavigationLinks
    }
    meteo: prismicDocument (type: {eq: "menu_meteo"}){
      ...MenuMeteo
    }
    allPagesUrl: allSitePage {
      ...PagesUrl
    }
    content: prismicDocument(type: {eq: "contact"}) {
      data {
        meta_description 
        meta_title
        header_images {
          slideshow_image {
            url
            alt
            xl { url }
            md { url }
            sm { url }
          }
        }
        image {
          url
          xl { url }
          md { url }
          sm { url }
        }
        introduction {
          text
          type
          spans {
            start
            end
            type
          }
        }
        action
        background {
          url
          xl { url }
          md { url }
          sm { url }
        }
        body {
          primary {
            text_content {
              type
              text
              spans {
                start
                end
                type
              }
            }
            link_to_a_content {
              slug
              data {
                title {
                  text
                }
              }
            }
            image {
              dimensions {
                width
                height
              }
              url 
              xl { url }
              md { url }
              sm { url }
            }
          }
        }
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/contact.js